import { render } from "./otherTable.vue?vue&type=template&id=2258704c&scoped=true"
import script from "./otherTable.vue?vue&type=script&lang=js"
export * from "./otherTable.vue?vue&type=script&lang=js"

import "./otherTable.vue?vue&type=style&index=0&id=2258704c&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2258704c"]])

export default __exports__